"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Box_1 = require("../Box");
function Spacer() {
    return jsx_runtime_1.jsx(Box_1.Box, { flex: 1, justifySelf: "stretch", alignSelf: "stretch" }, void 0);
}
exports.Spacer = Spacer;
//# sourceMappingURL=index.js.map